import TextArea from 'antd/lib/input/TextArea'
import Title from 'antd/lib/typography/Title'
import classes from './TextAnnotationsTaskUI.module.less'
import { useCallback, useEffect, useRef, useState } from 'react'
import { AnnotationSelection, AnnotationSelectionRange } from 'Types/Classes.types'
import Button from 'antd/lib/button'

type TextAnnotationsCommentPropsType = {
    selectedAnnotationId: string | null
    resetAnnotationId: () => void
    selectedAnnotationSelection?: AnnotationSelection
    offset: { top: number; left: number; width: number }
    comment: string
    updateAnnotationComment: (annotationId: string, comment: string) => void
}

export const TextAnnotationsComment: React.FC<TextAnnotationsCommentPropsType> = (
    props: TextAnnotationsCommentPropsType
) => {
    const [input, setInput] = useState('')
    const commentsContainerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (props.selectedAnnotationId !== null) {
            setInput(props.comment)
        }
    }, [props.comment, props.selectedAnnotationId])

    const handleClickOutside = useCallback((event: React.MouseEvent) => {
        if (
            commentsContainerRef.current &&
            !commentsContainerRef.current.contains(event.target as Node)
        ) {
            setInput('')
            props.resetAnnotationId()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onClickCancel = useCallback(() => {
        setInput('')
        props.resetAnnotationId()
    }, [props])

    const onClickSave = useCallback(() => {
        props.updateAnnotationComment(props.selectedAnnotationId!, input)
        props.resetAnnotationId()
    }, [input, props])

    const range: AnnotationSelectionRange = props.selectedAnnotationSelection
        ?.individualRowSelectionRange[0] ?? {
        positionStartY: 0,
        positionStartX: 0,
        positionWidth: 0,
        index: 0,
    }

    if (props.selectedAnnotationId === null) {
        return null
    }

    return (
        <>
            <div
                className={classes['comments-content-overlay']}
                onClick={handleClickOutside}
                onKeyDown={() => {}}
            >
                <div
                    ref={commentsContainerRef}
                    className={classes['comments-content']}
                    style={{
                        top: Math.min(range?.positionStartY + 5, window.innerHeight - 220),
                        left: Math.min(
                            range?.positionStartX,
                            props.offset.width + props.offset.left - 330
                        ),
                    }}
                >
                    <Title className={classes['comments-content-title']}>Add comment</Title>
                    <TextArea
                        className={classes['comments-content-textarea']}
                        placeholder="Type your comment here"
                        rows={4}
                        value={input}
                        onChange={e => setInput(e.target.value)}
                    />
                    <div className={classes['comments-content-buttons']}>
                        <Button
                            type="default"
                            className={classes['cancel']}
                            onClick={onClickCancel}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" className={classes['add']} onClick={onClickSave}>
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}
